import e from"./is-regexp.js";var o=e,p=TypeError,t=function(r){if(o(r))throw p("The method doesn't accept regular expressions");return r};export{t as default};
